import { Colors } from "veneer/Theme";

type TypeActionMap<T> = Record<string, Record<string, T | [T, T]>>;

const COLOR_CODE_MAP: Record<string, string> = {
  blue: Colors.blue700,
  red: Colors.red700,
  olive: Colors.green800,
  orange: Colors.orange400,
  lime: Colors.green400,
  yellow: Colors.yellow700,
  green: Colors.green700,
  maroon: Colors.pink600,
  teal: Colors.teal700,
  navy: Colors.blue800,
  fuchsia: Colors.magenta500,
  purple: Colors.purple700,
  aqua: Colors.teal500,
  black: Colors.black,
};

const TYPE_ACTION_COLOR_MAP: TypeActionMap<string> = {
  DEVICE: {
    NEW: "blue",
    ONLINE: "green",
    OFFLINE: "red",
    DELETE: "navy",
    DOWNGRADE: "orange",
    UPGRADE: "blue",
    RESTART: "maroon",
  },
  INAPP: {
    CRASH: ["black", "yellow"],
  },
  DEPLOY: {
    NEW: "purple",
    DEPLOY: "purple",
  },
  ACCOUNT: {
    INVITE: "teal",
    REGISTER: "aqua",
  },
};

const TYPE_ACTION_ICON_MAP: TypeActionMap<string> = {
  DEVICE: {
    NEW: "plus-square",
    ONLINE: "arrow-up",
    OFFLINE: "arrow-down",
    DELETE: "times",
    DOWNGRADE: "arrow-circle-o-down",
    UPGRADE: "arrow-circle-o-up",
    RESTART: "refresh",
  },
  INAPP: {
    CRASH: ["medkit", "warning"],
  },
  DEPLOY: {
    NEW: "cloud-upload",
    DEPLOY: "cloud-download",
  },
  ACCOUNT: {
    INVITE: "envelope",
    REGISTER: "user-plus",
  },
};

const TYPE_ACTION_NAME_MAP: TypeActionMap<string> = {
  DEVICE: {
    NEW: "New Device",
    ONLINE: "Device is Online",
    OFFLINE: "Device is Offline",
    DELETE: "Device Deleted",
    DOWNGRADE: "Device Downgraded",
    UPGRADE: "Device Upgraded",
    RESTART: "Device Started",
  },
  INAPP: {
    CRASH: ["Application Crash", "Application Warning"],
  },
  DEPLOY: {
    NEW: "App Uploaded",
    DEPLOY: "Strategy deployed",
  },
  ACCOUNT: {
    INVITE: "User Invited",
    REGISTER: "User Registered",
  },
};

export {
  COLOR_CODE_MAP,
  TYPE_ACTION_COLOR_MAP,
  TYPE_ACTION_ICON_MAP,
  TYPE_ACTION_NAME_MAP,
};
